<script>
import { useConfigStore, useUserStore } from '~/store/index.ts'

export default {
    name: 'NotificationAlertesPopup',
    props: {
        // data: { type: Object, required: true },
        // translationName: { type: String, required: true },
        // validation: { type: Object, required: false, default: null },
        // validationRules: { type: Object, required: false, default: () => {} },
    },
    emits: [],
    data() {
        const { user } = useUserStore()
        const { currentConfig } = useConfigStore()
        const dept = currentConfig.code_departement
        return {
            alerts: [],
            user,
            currentConfig,
            dept,
        }
    },
    mounted() {
        // GET ACTIVE ALERTS
        if (this.$route.name !== 'connexion') {
            this.$api.setRequest({
                url: 'alerts?filter[where_active]=true&filter[show_website]=true&filter[for_user_territory]=true',
                method: 'GET',
            }).then((res) => {
                this.alerts = res.data
                if (this.alerts.length) {
                    this.$refs.alertesPopup?.showModal()
                }
            })
        }
    },
}
</script>

<template>
    <ModalMiddle
        ref="alertesPopup"
        :is-form="false"
        custom-button-block
        :title-modal="`${$translate('notificationAlert.index')} ${user.organization ? user.organization?.name : $translate(dept)}`"
        :max-width="800"
        hide-default-actions
        persistent
    >
        <template #content>
            <v-alert
                v-for="alert in alerts" :key="alert.id" class="mb-5"
                :color="$getColor(`notificationAlert.level.${alert.level}`)"
                density="compact"
                elevation="1"
            >
                <template #title>
                    <!--
                    Du {{ $formatDateTime(alert.start_date) }} <template v-if="alert.end_date">au {{ $formatDateTime(alert.end_date) }}</template>
-->
                    Du {{ $formatDate(alert.start_date) }} <template v-if="alert.end_date">
                        au {{ $formatDate(alert.end_date) }}
                    </template>
                </template>
                <v-chip v-if="alert.burning_forbidden" variant="flat" size="x-small" color="danger">
                    Interdiction de brûlages sur la période
                </v-chip>
                <div class="mt-2">
                    {{ alert.description }}
                </div>
            </v-alert>
            <div class="mt-2 text-right">
                <v-btn color="dark" size="small" @click="$refs.alertesPopup.closeModal()">
                    J’ai pris connaissance
                </v-btn>
            </div>
        </template>
    </ModalMiddle>
</template>

<style scoped>
.v-alert.v-alert--border {
    --v-border-opacity: 1 !important;
}
</style>
